import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CommonCloudFirestore } from '../../../features/services/CommonCloudFirestore';
import { DOCUMENT_LISTENER } from '../../../shared/types/firestoreType';

import Layout from '../Layout/Index';
import Home from '../../../features/components/Home/Index';
import Product from '../../../features/components/Product/Index';
import ProductDetail from '../../../features/components/ProductDetail/Index';

export default function Index() {
    const listenersFirestore = new CommonCloudFirestore(DOCUMENT_LISTENER);
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    useEffect(() => {
        load();
    }, []);

    const load = async () => {
        listenersFirestore.onSnapshotDocuments((documents) => {
            documents.forEach(item => {
                const listenerValue = localStorage.getItem(`${item.id}-key`);
                if (!listenerValue || listenerValue !== item.value)
                    localStorage.removeItem(item.id);

                localStorage.setItem(`${item.id}-key`, item.value);
            });

            setIsFirstLoad(false);
        });
    };

    if (isFirstLoad) {
        return (<div>Loading</div>);
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route exact path="/" element={<Layout />}>
                    <Route exact path="/" element={<Home />} />
                    <Route exact path="/home" element={<Home />} />
                    <Route exact path="/product" element={<Product />} />
                    <Route exact path="/product-search" element={<Product />} />
                    <Route exact path="/product-cover/:coverId" element={<Product />} />
                    <Route exact path="/product-category/:categoryId" element={<Product />} />
                    <Route exact path="/product-section/:sectionId" element={<Product />} />
                    <Route exact path="/product-detail/:id" element={<ProductDetail />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}